module.exports = __webpack_public_path__ + "static/media/pdp_boat_banner-mob.ad80f6a4.png";